import { useState } from "react";
import editicon from "../../Images/editicon.png";
import mobile_icon from "../../Images/mobile_icon.png";
import phone_icon from "../../Images/phone_icon.png";
import whatsapp_icon from "../../Images/whatsapp_icon.png";
import mail_icon from "../../Images/mail_icon.png";
import website_icon from "../../Images/website_icon.png";
import location from "../../Images/location.png";
import arrowdirections from "../../Images/arrowdirections.png";
import Companyinfoeditmodal from "../../Modal/Companyinfoeditmodal";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { openWhatsAppLink, openWindow } from "../../Component/OpenWhatsApp";
import RewardPoints from "../../utils/RewardPoints";
import HttpClient from "../../utils/HttpClient";

const ContactDetailItem = ({ icon, text, address = "", emirate = "", country = "" }) => {
  return (
    <div className="infodetatddivfllsxdlx">
      <div className="indfodetatildiv">
        <img src={icon} alt="icon" />
      </div>
      <p className="ingfddtertrrxrpp">{text || "N/A"}{address && <><br />{address}</>}{emirate && country && <><br />{emirate + ", " + country}</>}
      </p>
    </div>
  );
};

const Contactdetaiilsprofile = ({ data = {}, setData, updateForm, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [contactEditModal, setContactEditModal] = useState(false);
  const handleContactModalClick = () => setContactEditModal(!contactEditModal);

  const handleOpenInNewTab = (e) => {
    e.preventDefault();
    window.open(data?.businessLocationLink, '_blank', 'noopener,noreferrer');
  };

  const handleWhatsAppClick = async (e, whatsAppCode, whatsAppNo, id) => {
    e.preventDefault();
    if (!whatsAppCode || !whatsAppNo) {
      return;
    }
    await addRewardPoints(id, RewardPoints.WHATSAPP_CONTACT_TYPE);
    openWhatsAppLink(e, `${whatsAppCode}${whatsAppNo}`, "I got your contact from Neoo Search and interested in your profile")
  };

  const addRewardPoints = async (id, visitType, subType = '') => {
    return await HttpClient.requestData("getting-rewards", "POST", { profileId: id, type: visitType, subType });
  }

  const handleLinkClick = async (e, link, id, visitType, subType = '') => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }

    if (!link) return;

    const normalize = (l) => {
      let u = String(l).trim();
      if (!/^https?:\/\//i.test(u)) u = `https://${u}`;
      return encodeURI(u);
    };

    try {
      await addRewardPoints(id, visitType, subType);
      openWindow(normalize(link));
    } catch (err) {
      console.error("Error opening website link:", err);
    }
  };

  return (
    <>
      <div className="contactdetsdiv">
        <div className="contactdetsdivdivbmain">
          <div className="consttactdetatlsarroedyrdiv">
            <p className="cinnattddttdtsttspo">Contact Details</p>
            {
              UserProfileID?._id === data?._id && updateForm !== undefined &&
              <>
                <div className="editeiconimg" onClick={handleContactModalClick}>
                  <img src={editicon} alt="edit icon" />
                </div>
              </>
            }

          </div>
          <div className="indfodetatildivmainui">
            <Link to={`tel:${data?.phone_code || ""}${data?.telephoneNo || ""}`}>
              <ContactDetailItem
                icon={phone_icon}
                text={`${data?.phone_code || ""} ${data?.telephoneNo || ""}`}
              />
            </Link>
            <Link to={`tel:${data?.phone_code || ""}${data?.mobileNo || ""}`} className="m-1">
              <ContactDetailItem
                icon={mobile_icon}
                text={`${data?.phone_code || ""} ${data?.mobileNo || ""}`}
              />
            </Link>
            {data?.whatsappNo && (
              <Link onClick={(e) => handleWhatsAppClick(e, data.whats_code, data.whatsappNo, data?._id)} className="m-1">
                <ContactDetailItem
                  icon={whatsapp_icon}
                  text={`${data?.whats_code || ""} ${data?.whatsappNo || ""}`}
                />
              </Link>
            )}
            <Link to={`mailto:${data?.emailId || ""}`} className="m-1">
              <ContactDetailItem icon={mail_icon} text={data?.emailId || ""} />
            </Link>
            {data?.businessWebsiteLink && (
              <Link onClick={(e) => handleLinkClick(e, data?.businessWebsiteLink, data?._id, RewardPoints.WEBSITE_LINK_VISIT_TYPE)} target="_blank" className="m-1">
                <ContactDetailItem
                  icon={website_icon}
                  text={data?.businessWebsiteLink || ""}
                />
              </Link>
            )}
          </div>
        </div>

        <div className="contactdetsdivdivbmaindivbtm">
          <ContactDetailItem icon={location} text={data?.address} address={data?.location} emirate={data?.emirate} country={data?.countryName} />
          <div className="direxrrcttstbtnmain">
            <button className="direxrrcttstbtn" onClick={handleOpenInNewTab}>
              Get Directions
              <img src={arrowdirections} alt="arrow icon" />
            </button>
            {/* <Link
            to="/"
            className="direxrrcttstbtn"
            onClick={handleOpenInNewTab}
            >
              Get Directions
              <img src={arrowdirections} alt="arrow icon" />
            </Link> */}
          </div>
        </div>
      </div>

      {contactEditModal && (
        <Companyinfoeditmodal
          data={data}
          closemodal={handleContactModalClick}
          updateForm={updateForm}
          setData={setData}
          setIsUpdate={setIsUpdate}
        />
      )}
    </>
  );
};

export default Contactdetaiilsprofile;
